import { cleanSupplierArticles } from '@/utils/nomenclature/articles'

import type { CreatedNomenclature } from '../api/singularImportApi'
import type { NomenclatureCreationType } from '../SingularImport.config'

export type CreatedNomenclatureItem = { label: string; value: string }

type ResultPaths = { group: string[]; category: string[] }

const PATH_SEPARATOR = ' › '

const withUnit = (value: string | undefined, unit: string) =>
  value ? `${value} ${unit}` : ''

export const buildCreatedNomenclatureItems = (
  nomenclature: CreatedNomenclature,
  values: NomenclatureCreationType,
  paths: ResultPaths
): CreatedNomenclatureItem[] =>
  [
    { label: 'Код', value: String(nomenclature.code) },
    { label: 'Артикул', value: nomenclature.article },
    {
      label: 'Артикулы поставщика',
      value: cleanSupplierArticles(values.supplierArticles ?? []).join(', '),
    },
    { label: 'Бренд', value: nomenclature.brandDto?.description ?? '' },
    {
      label: 'Группа номенклатуры',
      value:
        paths.group.join(PATH_SEPARATOR) ||
        (nomenclature.parentModel?.description ?? ''),
    },
    {
      label: 'Категория',
      value:
        paths.category.join(PATH_SEPARATOR) ||
        (nomenclature.categoryDto?.description ?? ''),
    },
    { label: 'Штрихкод', value: values.barcode ?? '' },
    { label: 'Вес', value: withUnit(values.itemWeight, 'кг') },
    { label: 'Длина', value: withUnit(values.itemLength, 'см') },
    { label: 'Ширина', value: withUnit(values.itemWidth, 'см') },
    { label: 'Высота', value: withUnit(values.itemHeight, 'см') },
    { label: 'Гарантия', value: withUnit(values.warranty, 'мес.') },
    {
      label: 'Страна происхождения',
      value: nomenclature.countryDto?.description ?? '',
    },
    {
      label: 'Единица измерения',
      value: nomenclature.unitOfMeasurementDto?.description ?? '',
    },
    { label: 'Описание', value: values.details ?? '' },
    { label: 'Комментарий', value: values.comment ?? '' },
  ].filter((item) => item.value.trim() !== '')
